import React, { useContext, useEffect, useState } from 'react';
import { Box, TextField, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { DataGridPro } from '@mui/x-data-grid-pro';
// CONST
import { withAgendaColumn, withoutAgendaColumn } from '../state/const';
// API
import { getDoctorEnagagementHistoryDetail } from '../../../api/mdProfileApi';
// CONTEXT
import { useMdProfileContext } from '../context/useMdProfileContext';

export default function EngagementHistoryModal({
  detailState,
  setDetailState,
  defaultDetailState,
}) {
  const { viewProfile } = useContext(useMdProfileContext);

  const filterformDefault = {
    basic_info_profile_id: viewProfile?.doctor_id,
    agenda_options_id: detailState?.row?.agenda_option_id,
    rep_id: detailState?.rep_id,
    year: detailState?.year,
  };
  // STATE
  const [touchpointDetailData, setTouchpointDetailData] = useState({ loading: false, items: [] });
  const [filterForm, setFilterForm] = useState(filterformDefault);

  const columns = filterForm?.agenda_options_id !== null ? withAgendaColumn : withoutAgendaColumn;

  const handleClose = () => {
    setDetailState(defaultDetailState);
  };

  const handleChangeDate = (value) => {
    setFilterForm({ ...filterForm, year: moment(value).format('YYYY') });
  };

  const handleTouchpointDetail = async () => {
    setTouchpointDetailData({ ...touchpointDetailData, loading: true });

    const requuest = {
      basic_info_profile_id: filterForm?.basic_info_profile_id,
      agenda_options_id: filterForm?.agenda_options_id,
      rep_id: filterForm?.rep_id,
      year: filterForm?.year,
    };

    const response = await getDoctorEnagagementHistoryDetail(requuest);
    const { code, data } = response.data;

    if (code === '200') {
      setTouchpointDetailData({ ...touchpointDetailData, loading: false, items: data });
    }
  };

  useEffect(() => {
    handleTouchpointDetail();
  }, [filterForm]);

  return (
    <Dialog open={detailState?.toggle} onClose={handleClose} maxWidth='lg' fullWidth>
      <DialogTitle>
        {detailState?.row?.name}
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box display='flex' justifyContent={'flex-end'} pb={2}>
          <DesktopDatePicker
            label='Year'
            views={['year']}
            value={filterForm?.year}
            fullWidth
            onChange={(e) => handleChangeDate(e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Box>
        <Box
          className='table-container'
          sx={{
            height: `800px`,
            '& .super-app-theme--header': {
              fontWeight: 'bold',
              backgroundColor: '#6B8D3E',
              color: '#fff',
            },
          }}
        >
          <DataGridPro
            loading={touchpointDetailData?.loading}
            rows={touchpointDetailData?.items}
            columns={columns}
            initialState={{
              ...touchpointDetailData?.items?.initialState,
              pagination: {
                pageSize: 50,
              },
            }}
            rowsPerPageOptions={[25, 50, 100]}
            pagination
            getRowClassName={(params) => {
              return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
